<template>
    <UiHeaderButton
        v-if="$page.props.manual"
        :title="lang('manual::manual.title')"
        dusk="manual-button"
        @click.stop="drawer.toggle()"
    >
        <icon icon="phosphor/regular/question" class="w-5 h-5 cursor-pointer"></icon>
    </UiHeaderButton>
</template>

<script setup lang="ts">
import { lang } from '@/lang/composable';
import { useManualDrawer } from '@src/Manual/Pages/composables/useManualDrawer';

const drawer = useManualDrawer();
</script>
